import { App, Component, ComponentPublicInstance, createApp } from "vue";
import * as microsoftTeams from "@microsoft/teams-js";

import Application from "./App.vue";
import router from "./router";
import editable from "./directives/editable";
import visible from "./directives/visible";
import autofocus from "vue-autofocus-directive";
import { TrackJS } from "trackjs";
import "@/global-scss/global.scss";
import Buefy from "@ntohq/buefy-next/src";
import SVGIcon from "@/components/SVGIcon.vue";
import VueTippy from "vue-tippy";
import "tippy.js/dist/tippy.css";
import { createPinia } from "pinia";

const pinia = createPinia();

const app = createApp(Application as unknown as Component)
  .use(router)
  .use(pinia) as unknown as App;

TrackJS.install({
  token: "b784bd4d4eac4f46a055b4b1771f56a7",
  application: "thoth"
});

app.use(VueTippy);
app.use(Buefy);
app.component("SVGIcon", SVGIcon as unknown as Component);

app.directive("editable", editable);
app.directive("visible", visible);
app.directive("autofocus", autofocus);

app.config.warnHandler = function (
  msg: string,
  vm: ComponentPublicInstance | null,
  trace: string
) {
  console.warn(`${msg}\n${trace}`);
};
app.config.errorHandler = (
  err: unknown,
  vm: ComponentPublicInstance | null,
  info: string
) => {
  const isProd = process.env.NODE_ENV === "production";

  if (vm?.$options.propsData) {
    TrackJS.console.log("Props passed to component", vm.$options.propsData);
  }

  let infoMessage = vm ? `Error in component: <${vm.$options.name} />\n` : "";
  if (info) {
    infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
  }
  TrackJS.console.log(infoMessage);

  const errorText = (err as Error).stack ? (err as Error).stack : String(err);

  if (isProd) {
    TrackJS.track(`THOTH: ${errorText}`);
  } else {
    console.error(errorText);
  }
};

// Initialize the Microsoft Teams SDK
microsoftTeams.initialize();

app.mount("#app");
